export const GET_USER = "GET_USER";
export const DELETE_REDUX = "DELETE_REDUX";